export function thematicBreak() {
	return { type: 'thematicBreak' as const };
}
